var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 4.01837L18.0687 8.15852C18.3487 8.73484 19.0952 9.28764 19.7252 9.39349L23.4464 10.0169C25.8262 10.4168 26.3862 12.1575 24.6713 13.8747L21.7783 16.7916C21.2883 17.2856 21.0201 18.2383 21.1717 18.9206L22 22.5314C22.6532 25.3895 21.1483 26.4952 18.6403 25.0014L15.1524 22.9196C14.5225 22.5432 13.4843 22.5432 12.8426 22.9196L9.35469 25.0014C6.85829 26.4952 5.3418 25.3777 5.99506 22.5314L6.8233 18.9206C6.97494 18.2383 6.70665 17.2856 6.21669 16.7916L3.32369 13.8747C1.62054 12.1575 2.16882 10.4168 4.54855 10.0169L8.26981 9.39349C8.88807 9.28764 9.63465 8.73484 9.91462 8.15852L11.9677 4.01837C13.0876 1.77187 14.9074 1.77187 16.0156 4.01837Z",
    stroke: "#161E21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIcon);
export default __webpack_public_path__ + "static/media/RateIcon.02fc1f6cbc4cef5ddafa5b40d1007561.svg";
export { ForwardRef as ReactComponent };